// @ts-nocheck
import React from 'react'

import { Icon, ChevronDownIcon } from 'components/shared/Icon/Icon'

import styles from './DropdownIndicator.module.scss'

export const DropdownIndicator = () => (
  <Icon className={styles.indicator} icon={ChevronDownIcon} size={24} />
)
